import CardDataStateBlock from './CardDataStateBlock';

export default CardDataStateBlock;

export type { ICardDataStateBlockProps } from './CardDataStateBlock';
